import {defineAsyncComponent} from 'vue';

const GeneralJournalEntryDetail = defineAsyncComponent(() =>
  import('@/views/ledger/otherLedger/GeneralJournalEntryDetail.vue'),
);

const AssetEvaluationDetail = defineAsyncComponent(() =>
  import('@/views/ledger/assetEvaluation/AssetEvaluationDetail.vue'),
);


const listSubmitedReport = defineAsyncComponent(() => import('@/views/ledger/submitReport/ListSubmitedReport.vue'));

const ParentOrgChosen = defineAsyncComponent(() => import('@/views/ledger/submitReport/ParentOrgChosen.vue'));

const ConfirmSubmitReport = defineAsyncComponent(() => import('@/views/ledger/submitReport/ConfirmSubmitReport.vue'));

const SubmitedReportHistory = defineAsyncComponent(() =>
  import('@/views/ledger/submitReport/SubmitedReportHistory.vue'),
);

export function registerLedger(app) {
  app.component('GeneralJournalEntryDetail', GeneralJournalEntryDetail);
  app.component('AssetEvaluationDetail', AssetEvaluationDetail);
  app.component('ListSubmitedReport', listSubmitedReport);
  app.component('ParentOrgChosen', ParentOrgChosen);
  app.component('ConfirmSubmitReport', ConfirmSubmitReport);
  app.component('SubmitedReportHistory', SubmitedReportHistory);
}
